/**
 * @generated SignedSource<<d78a6af3f633ded74a7dbc919a4b146e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateGitHubInstallationLinkInput = {
  source?: string | null | undefined;
};
export type GitHubIntegrationsDialogCreateInstallationLinkMutation$variables = {
  input?: CreateGitHubInstallationLinkInput | null | undefined;
};
export type GitHubIntegrationsDialogCreateInstallationLinkMutation$data = {
  readonly createGithubInstallationLink: {
    readonly installationLink: string;
  };
};
export type GitHubIntegrationsDialogCreateInstallationLinkMutation = {
  response: GitHubIntegrationsDialogCreateInstallationLinkMutation$data;
  variables: GitHubIntegrationsDialogCreateInstallationLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGitHubInstallationLinkPayload",
    "kind": "LinkedField",
    "name": "createGithubInstallationLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "installationLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GitHubIntegrationsDialogCreateInstallationLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GitHubIntegrationsDialogCreateInstallationLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3fe48d814f95c0d3b71e39882be07005",
    "id": null,
    "metadata": {},
    "name": "GitHubIntegrationsDialogCreateInstallationLinkMutation",
    "operationKind": "mutation",
    "text": "mutation GitHubIntegrationsDialogCreateInstallationLinkMutation(\n  $input: CreateGitHubInstallationLinkInput\n) {\n  createGithubInstallationLink(input: $input) {\n    installationLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "3986f5fe7a4b7822a246cc126bb30f76";

export default node;
